import { createSlice } from "@reduxjs/toolkit";
import { walletApi } from "@/store/api/walletApi";
import { RootState } from "@/store/store";

interface ConversionState {
  satsToUsd: number | null;
  updatedAt: number | null;
}

const initialState: ConversionState = {
  satsToUsd: null,
  updatedAt: null,
};

const conversionSlice = createSlice({
  name: "conversion",
  initialState,
  reducers: {
    resetConversion: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addMatcher(walletApi.endpoints.convertCrypto.matchFulfilled, (state, action) => {
      const { amount, from, to, result } = action.payload;

      if (amount !== 1 || from !== "SATS" || to !== "USD") {
        return;
      }

      state.satsToUsd = result;
      state.updatedAt = Date.now();
    });
  },
});

export const { resetConversion } = conversionSlice.actions;

export const selectConversion = (state: RootState) => state.conversion;

export default conversionSlice.reducer;
